import React from 'react';
import medialunasSapore from '../media/background_images/medialunas-sapore.png'

const HomeBanner = ({featuredProductsLine}) => {
    return (
        <div className="sdp-hero" style={{backgroundImage: `url(${medialunasSapore})`}}>
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-5 col-sm-offset-1 col-md-5 col-md-offset-0">
                        <h3 className="sdp-hero-title">{featuredProductsLine.Titulo}</h3>
                        <p className="font24 hidden-xs">
                            {featuredProductsLine.Descripcion}
                        </p>
                        <a href={featuredProductsLine.Link}
                           className={`${!featuredProductsLine.NombreLink ? "hidden" : ""} btn btn-primary btn-lg btn-outlined make-order`}>
                            {featuredProductsLine.NombreLink}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default HomeBanner;